import { oc } from '@orpc/contract';
import { purchaseEstimateInputSchema } from '../schemas/estimates.schemas.js';
import { purchaseEstimateOutputSchema } from '../schemas/purchase.schemas.js';
/**
 * **The single origin of inventory** (plan §3.1, §5.6).
 *
 * One transaction: lock the estimate, re-check the purchase rule against freshly loaded context, take the
 * next stock number from the tenant counter, insert the vehicle from the estimate's own fact columns,
 * copy the inspection, the cost items, the latest snapshot and the activity, write a `PURCHASE` snapshot
 * priced at what was actually paid, close the estimate as `DEAL_AGREED` and consume the approval. Any
 * refusal rolls all of it back — there is no half-created vehicle.
 */
export const purchaseEstimateContract = oc
    .route({
    method: 'POST',
    path: '/estimates/{estimateId}/purchase',
    tags: ['Estimates'],
    summary: 'Confirm the purchase and create the stock vehicle',
})
    .input(purchaseEstimateInputSchema)
    .output(purchaseEstimateOutputSchema);
//# sourceMappingURL=purchase-estimate.contract.js.map